/* eslint-disable @typescript-eslint/no-explicit-any */
import { EFieldType, IFieldMeta, IListColumnMeta } from 'shared/types/Page.interface';
import { concatString } from 'shared/utils';

const prepareValue = (el: string) => el?.toLowerCase().replace(/[ё]/g, 'е').replace(/[^а-яА-Яa-zA-Z0-9]/g, '');

const checkValueMatches = (record: any, filter: string, column: IFieldMeta) => {
  switch (column.type) {
  case EFieldType.select:
    return prepareValue(column.options[record[column.dataIndex]]).includes(prepareValue(filter));
  case EFieldType.colored:
    return prepareValue(column.selectOptions[record[column.dataIndex]]).includes(prepareValue(filter));
  case EFieldType.template:
    return prepareValue(concatString(column.keys.map(((key) => record[key]))))?.includes(prepareValue(filter));
  case EFieldType.picklist:
    return prepareValue(record[column.dataIndex]?.[column.pickMap.valueKey])?.includes(prepareValue(filter));
  case EFieldType.tags:
  case EFieldType.dateTime:
    return false;
  default:
    return record[column.dataIndex]
      ? prepareValue(record[column.dataIndex].toString()).includes(prepareValue(filter))
      : false;
  }
};

export const filterDataSource = (dataSource: any[], filter: string, columns: IListColumnMeta) => {
  const result = filter
    ? dataSource.filter((record) => columns.findIndex((column) => checkValueMatches(record, filter, column)) > -1)
    : dataSource;
  return result;
};
